import { React } from "react";

function UserModels(props) {
  
  return (
    <div id="modelOff">
      {props.isModalOpen && (
        <div
          className="modal fade show"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          ref={props.textInput}
        >
          <div className="modal-dialog modal-dialog-centered m-auto">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title m-auto" id="staticBackdropLabel">
                  Update Status
                </h5>           
              </div>
              <div className="modal-body m-auto">
                <div className="form-group  mt-4">
                  <label htmlFor="Name">Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={props.name}
                    onChange={(e) => {
                      props.setName(e.target.value);
                    }}
                    className="form-control input"
                    placeholder="Enter Your Name"
                  />
                </div>

                <div className="form-group  mt-4">
                  <label htmlFor="Name">Number:</label>
                  <input
                    type="number"
                    name="status"
                    value={props.pNumber}
                    onChange={(e) => {
                      props.setPNumber(e.target.value);
                    }}
                    className="form-control input"
                    placeholder="Number"
                  />
                </div>
                <div className="form-group  mt-4">
                  <label htmlFor="ComplaintNumber">ComplaintNumber:</label>
                  <input
                    type="text"
                    name="ComplaintNumber"
                    value={props.complaintNumber}
                    onChange={(e) => {
                      props.setComplaintNumber(e.target.value)
                    }}
                    className="form-control input"
                    placeholder="complaintNumber"
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="form-btn btn-primary mt-4 mb-2 m-auto"
                    onClick={props.updateUser}
                  >
                    Submit
                  </button>
                </div>
                <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    props.setModalStatus(false);
                  }
                  }
                >
                  Close
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserModels;
